// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CallCustomPermissionsBlock__wrapper-ca5cf2 {
  overflow-y: auto;
}

.CallCustomPermissionsBlock__component-d942b2 {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.CallCustomPermissionsBlock__list-be9317 {
  display: flex;
  flex-direction: column;
  margin-top: 12px;
}

.CallCustomPermissionsBlock__divider-cd3cd5 {
  height: 1px;
  display: flex;
  flex: 1;
  margin: 32px 24px 0 24px;
  background: var(--base-20);
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/popups/Permissions/CallPermissionsPopup/components/CallCustomPermissionsBlock/CallCustomPermissionsBlock.styles.m.css"],"names":[],"mappings":"AAAA;EACE,gBAAA;AACF;;AACA;EACE,OAAA;EACA,aAAA;EACA,sBAAA;AAEF;;AACA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;AAEF;;AACA;EACE,WAAA;EACA,aAAA;EACA,OAAA;EACA,wBAAA;EACA,0BAAA;AAEF","sourcesContent":[".wrapper {\n  overflow-y: auto;\n}\n.component {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n.list {\n  display: flex;\n  flex-direction: column;\n  margin-top: 12px;\n}\n\n.divider {\n  height: 1px;\n  display: flex;\n  flex: 1;\n  margin: 32px 24px 0 24px;\n  background: var(--base-20);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `CallCustomPermissionsBlock__wrapper-ca5cf2`,
	"component": `CallCustomPermissionsBlock__component-d942b2`,
	"list": `CallCustomPermissionsBlock__list-be9317`,
	"divider": `CallCustomPermissionsBlock__divider-cd3cd5`
};
module.exports = ___CSS_LOADER_EXPORT___;
